import http, { Http } from '@/lib/http';
import { Connection } from './get_connection';

interface Credentials {
  containerId: string;
}

interface Params {
  projectId: string;
  credentials: Credentials;
}

function gtmConnectCtor(http: Http) {
  return async ({ projectId, credentials }: Params): Promise<Connection> => {
    const { data } = await http.post(`/projects/${projectId}/integrations/gtm`, { credentials });
    return data;
  };
}

export const gtmConnect = gtmConnectCtor(http);
